module.exports = __webpack_public_path__ + "img/Bader_Nasser.22aa30e6.png";